var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.spinner,"spinner-variant":"primary"}},[_c('b-card',[_c('clientesForm',{attrs:{"cliente":_vm.clienteData,"clienteSubmit":"Crear Cliente"},on:{"processCliente":_vm.agregarCliente}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }